export default {
  "content": "<path d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z\" fill=\"#1D1D1B\"/><path d=\"M10.686 13.413A7.543 7.543 0 018.49 8.489a7.499 7.499 0 014.907 2.203 7.549 7.549 0 012.195 4.924 7.499 7.499 0 01-4.906-2.203zm10.63 0a7.499 7.499 0 01-4.907 2.203 7.549 7.549 0 012.195-4.924 7.499 7.499 0 014.907-2.203 7.543 7.543 0 01-2.196 4.924zm0 5.173a7.543 7.543 0 012.195 4.924 7.5 7.5 0 01-4.907-2.203 7.549 7.549 0 01-2.195-4.923 7.499 7.499 0 014.906 2.202zm-10.63 0a7.563 7.563 0 014.932-2.203c-.1 1.854-.908 3.607-2.221 4.924A7.5 7.5 0 018.49 23.51a7.543 7.543 0 012.196-4.924z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};